var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJanazah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0C37.7548 0 48.5 10.7452 48.5 24Z",
    fill: "#CAD6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6564 19.7279L28.0594 34.792C27.8905 35.504 27.2786 36.003 26.5779 36H22.4235C21.7228 36.003 21.1109 35.504 20.942 34.792L17.345 19.7199C17.2457 19.299 17.3154 18.854 17.5359 18.4879L20.9572 12.752C21.234 12.284 21.7218 11.999 22.2478 12H26.7536C27.2796 11.999 27.7674 12.284 28.0442 12.752L31.4654 18.4879C31.6869 18.8569 31.7557 19.3049 31.6564 19.7279ZM27.031 20.292L27.031 20.2921C26.2954 20.633 25.309 20.6848 24.5505 20.2942C23.1597 19.5779 22.608 17.854 23.3242 16.4633C23.5195 16.0841 23.8413 15.7699 24.2262 15.4883C23.3968 15.7012 22.6595 16.2011 22.2363 17.0229C21.4874 18.4768 22.0394 20.2007 23.4932 20.9494C24.6943 21.568 26.1922 21.2996 27.031 20.2921L27.0311 20.292L27.031 20.292ZM27.1235 18.6163L26.3252 18.129L25.5269 18.6163L25.7336 17.6678L25.0337 17.0811L25.9218 16.8822L26.3252 16.0333L26.7286 16.8822L27.6167 17.0811L26.9168 17.6678L27.1235 18.6163Z",
    fill: "#021922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJanazah);
export default __webpack_public_path__ + "static/media/Janazah.284496d2cbfe6de43548371f734d8a60.svg";
export { ForwardRef as ReactComponent };